/* ---------------------------------------------------------------------
 *                           Import Library
 * --------------------------------------------------------------------- */

// LocalCache
import { saveToStorage, getFromStorage } from "./localCache";

/* ---------------------------------------------------------------------
 *                            Set/Get ChatData
 * --------------------------------------------------------------------- */

/**
 * 存储聊天数据到本地缓存
 * @param {Object} chatData - 聊天数据
 * @returns {void} 
 */
export function setChatData(chatData) {
    saveToStorage("ChatData", chatData);
}

/**
 * 从本地缓存中获取聊天数据
 * @return {Object} ChatData
 */
export function getChatData() {
    return getFromStorage("ChatData");
}